import { StarFilled } from "components/icons/generated";
import { TableColumnMeta } from "ds/components/Table/types";

export const STACKS_COLUMNS_STORAGE_KEY = "stacksTableColumnsConfig";

export enum STACKS_COLUMN_ID {
  STATE = "STATE",
  NAME = "NAME",
  ISSUES = "ISSUES",
  SETTINGS = "SETTINGS",
  FAVORITE = "FAVORITE",
  LABELS = "LABELS",
  SPACE = "SPACE",
  VENDOR = "VENDOR",
  BRANCH = "BRANCH",
  COMMIT = "COMMIT",
  REPOSITORY = "REPOSITORY",
  GIT_TAG = "GIT_TAG",
  PROJECT_ROOT = "PROJECT_ROOT",
  DELTA_COUNTS = "DELTA_COUNTS",
  UPDATED_AT = "UPDATED_AT",
  LAST_APPLY_ATTEMPT = "LAST_APPLY_ATTEMPT",
  DESCRIPTION = "DESCRIPTION",
  BLUEPRINT = "BLUEPRINT",
  ROW_ACTIONS = "ROW_ACTIONS",
}

const MAX_CELL_WIDTH = 2000;

export const STACKS_COLUMN_CONFIG: Record<STACKS_COLUMN_ID, TableColumnMeta> = {
  [STACKS_COLUMN_ID.STATE]: {
    id: STACKS_COLUMN_ID.STATE,
    title: "State",
    minWidth: 180,
    defaultWidth: 240,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [STACKS_COLUMN_ID.NAME]: {
    id: STACKS_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 180,
    defaultWidth: 220,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [STACKS_COLUMN_ID.ISSUES]: {
    id: STACKS_COLUMN_ID.ISSUES,
    title: "Issues",
    minWidth: 130,
    defaultWidth: 170,
    maxWidth: MAX_CELL_WIDTH,
    canHide: true,
    resizable: true,
    canPin: true,
    canMove: true,
  },
  [STACKS_COLUMN_ID.SETTINGS]: {
    id: STACKS_COLUMN_ID.SETTINGS,
    title: "Settings",
    minWidth: 130,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    canHide: true,
    resizable: true,
    canPin: true,
    canMove: true,
  },
  [STACKS_COLUMN_ID.FAVORITE]: {
    id: STACKS_COLUMN_ID.FAVORITE,
    title: "Favorite",
    iconOnly: true,
    icon: StarFilled,
    minWidth: 120,
    defaultWidth: 120,
    maxWidth: 120,
    resizable: false,
    allowsSorting: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [STACKS_COLUMN_ID.LABELS]: {
    id: STACKS_COLUMN_ID.LABELS,
    title: "Labels",
    minWidth: 140,
    defaultWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    canHide: true,
    resizable: true,
    canPin: true,
    canMove: true,
  },
  [STACKS_COLUMN_ID.SPACE]: {
    id: STACKS_COLUMN_ID.SPACE,
    title: "Space",
    minWidth: 160,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    canHide: true,
    canPin: true,
    canMove: true,
    resizable: true,
  },
  [STACKS_COLUMN_ID.VENDOR]: {
    id: STACKS_COLUMN_ID.VENDOR,
    title: "Vendor",
    minWidth: 130,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    canHide: true,
    resizable: true,
    canPin: true,
    canMove: true,
  },
  [STACKS_COLUMN_ID.BRANCH]: {
    id: STACKS_COLUMN_ID.BRANCH,
    title: "Branch",
    minWidth: 140,
    defaultWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    canHide: true,
    resizable: true,
    canPin: true,
    canMove: true,
  },
  [STACKS_COLUMN_ID.COMMIT]: {
    id: STACKS_COLUMN_ID.COMMIT,
    title: "Commit",
    minWidth: 140,
    defaultWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    canHide: true,
    resizable: true,
    canPin: true,
    canMove: true,
  },
  [STACKS_COLUMN_ID.REPOSITORY]: {
    id: STACKS_COLUMN_ID.REPOSITORY,
    title: "Repository",
    minWidth: 200,
    defaultWidth: 280,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    canHide: true,
    resizable: true,
    canPin: true,
    canMove: true,
  },
  [STACKS_COLUMN_ID.GIT_TAG]: {
    id: STACKS_COLUMN_ID.GIT_TAG,
    title: "Git tag",
    minWidth: 160,
    defaultWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    canHide: true,
    resizable: true,
    canPin: true,
    canMove: true,
  },
  [STACKS_COLUMN_ID.PROJECT_ROOT]: {
    id: STACKS_COLUMN_ID.PROJECT_ROOT,
    title: "Project root",
    minWidth: 180,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    canHide: true,
    resizable: true,
    canPin: true,
    canMove: true,
  },
  [STACKS_COLUMN_ID.DELTA_COUNTS]: {
    id: STACKS_COLUMN_ID.DELTA_COUNTS,
    title: "Delta",
    minWidth: 120,
    defaultWidth: 140,
    maxWidth: MAX_CELL_WIDTH,
    canHide: true,
    resizable: true,
    canPin: true,
    canMove: true,
  },
  [STACKS_COLUMN_ID.UPDATED_AT]: {
    id: STACKS_COLUMN_ID.UPDATED_AT,
    title: "Updated at",
    minWidth: 165,
    defaultWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    canHide: true,
    resizable: true,
    canPin: true,
    canMove: true,
  },
  [STACKS_COLUMN_ID.LAST_APPLY_ATTEMPT]: {
    id: STACKS_COLUMN_ID.LAST_APPLY_ATTEMPT,
    title: "Last apply attempt",
    minWidth: 200,
    defaultWidth: 220,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    canHide: true,
    resizable: true,
    canPin: true,
    canMove: true,
  },
  [STACKS_COLUMN_ID.DESCRIPTION]: {
    id: STACKS_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 150,
    defaultWidth: 240,
    maxWidth: MAX_CELL_WIDTH,
    canHide: true,
    resizable: true,
    canPin: true,
    canMove: true,
  },
  [STACKS_COLUMN_ID.BLUEPRINT]: {
    id: STACKS_COLUMN_ID.BLUEPRINT,
    title: "Blueprint",
    minWidth: 140,
    defaultWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    canHide: true,
    resizable: true,
    canPin: true,
    canMove: true,
  },
  [STACKS_COLUMN_ID.ROW_ACTIONS]: {
    id: STACKS_COLUMN_ID.ROW_ACTIONS,
    title: "Stack actions",
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    noHeader: true,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
    canPin: false,
    canMove: false,
  },
};
